/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Card component
 *
 * @author Thais Watanabe
 */
export default function Card(props) {
  return (
    <div
      className={`${props.className} bg-white shadow rounded-lg divide-y divide-gray-200 max-w-7xl mx-auto`}
    >
      {props.title && (
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {props.title}
          </h3>
        </div>
      )}
      <div className="px-4 py-5 sm:p-6">{props.children}</div>
    </div>
  );
}
